module.exports = __webpack_public_path__ + "img/collection-diamondJewelrySets@2x.4362a6a.jpg";